import { Injectable } from '@angular/core';
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TournamentService } from '../services/tournament/tournament.service';
import { Tournament } from '../models/tournament';

@Injectable({ providedIn: 'root' })
export class TournamentResolver implements Resolve<Tournament> {
    constructor(private tournamentService: TournamentService) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Tournament> {
        const id = route.params['tournamentId'];
        return this.tournamentService.getById(id);
    }
}
